module.exports = __webpack_public_path__ + "static/media/Artboard8.c80b1136.png";